import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useGetUserEntryQuery } from "services/auth/authService";
import { SchemaOptional } from "types/resourceTypes";
import { scrollToTop, loadExistingData, createFormData } from "helpers/utils";
import PSPage from "components/globals/ui/layout/Page";
import { EntryLoading, EntryError } from "components/globals/EntryStates";
import { PSWysiwyg } from "components/globals/ui/input/PSInputs";
import PSGallery from "components/globals/PSGallery";
import { ProgressBarResource, FormStage } from "components/globals/forms/ORSFormLayout";
import { useDispatch } from "react-redux";
import { updateEntry } from "store/authSlice";
import { ErrorPane } from "components/modals/Panes";
import { useNavigate } from "react-router-dom";


export default function ResourceOptional() {
	const { id } = useParams();
	const [loading, setLoading] = useState(true);
	const [errorMessage, setErrorMessage] = useState(null);
	const [postData, updatePostData] = useState(null);
	const userToken = useSelector((state) => state.auth.userToken);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const {
		data: existingEntryData,
		loading: entryLoading,
		error: entryError,
	} = useGetUserEntryQuery(`resource/${id}`, { skip: !id });

	useEffect(() => {
		if (existingEntryData) {
			loadExistingData(updatePostData, SchemaOptional, existingEntryData);
			setLoading(false);
		}
	}, [existingEntryData]);

	// coming from input onChange (text and select, type, category)
	const onInputChange = (context, val) => {
		setNewPostDataProperty(context, val);
	};

	const setNewPostDataProperty = (context, val) => {
		updatePostData((prevData) => ({
			...prevData,
			[context]: val,
		}));
	};

	const updateSelectedGalleryFiles = (images) => {
		setNewPostDataProperty("gallery", images);
	};

	// SUBMIT
	const submitForm = async () => {
		if (!userToken || (!id)) return;

		setLoading(true);
		setErrorMessage(null);

		let fd = createFormData(postData, SchemaOptional);
		fd.append("internal_id", id);

		try {
			await dispatch(updateEntry({ data: fd, entry_type: "resource" })).unwrap();
			navigate('/dashboard/notes#resources');
		} catch (err) {
			setErrorMessage(err.message || "Failed. Please try again.");
		} finally {
			setLoading(false);
			scrollToTop();
		}
	};

	const clearErrorMessage = () => {
		setErrorMessage(null);
	};

	if (entryLoading) {
		return <EntryLoading />;
	}
	if (entryError) {
		return <EntryError msg="Failed to load." />;
	}


	return (
		<PSPage>

			<ErrorPane
				visible={errorMessage}
				message={errorMessage}
				onClose={clearErrorMessage}
			/>

			<div className="relative">
				
				<ProgressBarResource stage={2} id={id} />


				<div className="mt-[60px]">

					{!loading && (
						<FormStage 
							heading={`Update resource: ${existingEntryData?.entry?.title}`}
							subheading="Optional Info" 
							onSave={submitForm}
							stage={2}
							stages={2}
							previousUrl={`/edit/resource/${id}`}
						>

							<PSWysiwyg
								name="body"
								label="Body"
								context="body"
								value={postData.body || ""}
								onChange={onInputChange}
							/>

							<h2 className=" text-[18px] mb-2">Main Image Gallery</h2>
							<PSGallery
								initialImages={postData.gallery || []}
								onImagesChange={updateSelectedGalleryFiles}
							/>

							{/* <h2 className=" text-[18px] mb-2 mt-6">File Upload Attachment</h2>
							<PSFileUpload
								name="document"
								label="Documents"
								context="document"
								value={postData.document || ""}
								onChange={onInputChange}
								acceptedTypes=".pdf,.jpg,.jpeg,.png,.gif,.doc,.docx,.txt"
								maxFileSizeMB={10}
								showPreview={true}
							/> */}
							
						</FormStage>
					)}

				</div>
			</div>
		</PSPage>
	);
}
